// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import pinFilled01Icon from "@/assets/icons/aop/pin-filled-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type PinFilled01IconProps = Omit<IconProps, "name">;

export function PinFilled01Icon(props: PinFilled01IconProps): React.ReactNode {
  return <Icon name={pinFilled01Icon} {...props} />;
}
